export const MEMBER_CITIZENSHIP_TYPES = [
  "lumora_citizen",
  "nexus_citizen",
  "explorer_citizen",
];

export const CITIZENSHIP_THEME = {
  explorer: { main: "#1A1A1A", secondary: "#A8B0B8", accent: "#F5F7FA" },
  nexus: { main: "#00E5A8", secondary: "#7BFFC9", accent: "#0F766E" },
  lumora: { main: "#C77DFF", secondary: "#E0AAFF", accent: "#6A00A8" },
};

export const getCitizenshipThemeKey = (citizenshipType) => {
  const raw = String(citizenshipType || "").toLowerCase();
  if (raw === "nexus_citizen") return "nexus";
  if (raw === "lumora_citizen") return "lumora";
  return "explorer";
};
